/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CbtPaperClassPerformanceSummaryResponse } from '../models/CbtPaperClassPerformanceSummaryResponse';
import type { Page_StudentPaperResultResponse_ } from '../models/Page_StudentPaperResultResponse_';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CbtClassPerformanceRestControllerService {
  /**
   * getPaperClassPerformanceStudents
   * @returns Page_StudentPaperResultResponse_ OK
   * @throws ApiError
   */
  public static getPaperClassPerformanceStudentsUsingGet({
    paperId,
    limit,
    offset,
    search,
  }: {
    /**
     * paper-id
     */
    paperId: string;
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_StudentPaperResultResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cbt/papers/{paper-id}/class-performance/students',
      path: {
        'paper-id': paperId,
      },
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getPaperClassPerformanceSummary
   * @returns CbtPaperClassPerformanceSummaryResponse OK
   * @throws ApiError
   */
  public static getPaperClassPerformanceSummaryUsingGet({
    paperId,
  }: {
    /**
     * paper-id
     */
    paperId: string;
  }): CancelablePromise<CbtPaperClassPerformanceSummaryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cbt/papers/{paper-id}/class-performance/summary',
      path: {
        'paper-id': paperId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
